import { render, staticRenderFns } from "./img-changer.vue?vue&type=template&id=40479c69&scoped=true"
import script from "./img-changer.vue?vue&type=script&lang=js"
export * from "./img-changer.vue?vue&type=script&lang=js"
import style0 from "./img-changer.vue?vue&type=style&index=0&id=40479c69&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40479c69",
  null
  
)

export default component.exports